import { PropertySearchResult } from '../dtos';
import { SearchResult } from '../types';

export function isPropertySearchResult(
  searchResult: SearchResult
): searchResult is PropertySearchResult {
  return (searchResult as PropertySearchResult).property_type !== undefined;
}
